<template>
  <div class="row mb-5">
    <div class="col">
      <p class="text-muted fs-5 mb-1">
        {{ $t('widgetSurveyInfo.startDate') }}
      </p>
      <p class="fs-4">
        {{ startDate }}
      </p>
    </div>
    <div class="col">
      <p class="text-muted fs-5 mb-1">
        {{ $t('widgetSurveyInfo.endDate') }}
      </p>
      <p class="fs-4">{{ endDate }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyInfoDates',
  props: {
    id: String,
    startDate: String,
    endDate: String
  }
}
</script>
